export const getters = {
  tarifs (state) {
  
    return state.tarifs
  },
  tarif (state) {
    return state.tarif
  },  
  pagination(state){
    return state.pagination
  }
}
